"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatNumber = exports.formatDiscount = exports.formatPrice = void 0;
const ocm_object_1 = require("./ocm-object");
const defaultCurrency = ocm_object_1.country === "ch" ? "CHF" : "EUR";
const formatPrice = (price, currencyIso = defaultCurrency) => {
    const _locale = currencyIso === "CHF" ? "de-CH" : "de-AT";
    return new Intl.NumberFormat(_locale, { style: "currency", currency: currencyIso, useGrouping: false }).format(Number(price));
};
exports.formatPrice = formatPrice;
const formatDiscount = (percentage) => `-${Math.floor(Math.abs(Number(percentage)))}%`;
exports.formatDiscount = formatDiscount;
const countryLocaleMap = { de: "de-DE", at: "de-AT", ch: "de-CH", int: "en" };
const numberFormatter = new Intl.NumberFormat((_a = countryLocaleMap[ocm_object_1.country]) !== null && _a !== void 0 ? _a : ocm_object_1.language);
const formatNumber = (number) => numberFormatter.format(Number(number));
exports.formatNumber = formatNumber;
